import { Box, Grid } from '@material-ui/core';
import { formatDateTimeReadable, Kyc } from '@nemuru-eng/js-api-client';

import { KycSecurityCheckList } from '@/components/modules/KYC/KYCLoan/BorrowerKYC/components/DocumentIdSection/components/KycSecurityCheckList';
import { getVerifierNameById } from '@/components/modules/KYC/KYCLoan/BorrowerKYC/components/DocumentIdSection/utils/getVerifierNameById';
import { CustomDivider } from '@/components/shared/components/CustomDivider';
import { Font } from '@/components/shared/components/Font';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { ReadOnlyDataRow } from '@/components/shared/components/ReadOnlyDataRow';
import { Text } from '@/components/shared/components/Text';
import { PendingDataType } from '@/config/types';
import { useScreen } from '@/hooks/useScreen';

export function KycForm({ kyc }: { kyc?: Kyc }) {
  const { isMobile } = useScreen();

  if (!kyc) return <></>;
  return (
    <Box pt={2}>
      <Grid container spacing={isMobile ? 0 : 4}>
        <Grid item xs={12}>
          <Box pt={2}>
            <ReadOnlyDataRow labelTextId={'DOCUMENT_NUMBER'} value={kyc.documentNumber} />
            <ReadOnlyDataRow
              labelTextId={'SIMILARITY_LEVEL'}
              value={kyc.similarityLevel ? <Text tId={kyc.similarityLevel} /> : '-'}
            />
            <ReadOnlyDataRow labelTextId={'CREATED_AT_FOR_TABLE'} value={formatDateTimeReadable(kyc.createdAt)} />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <>
            <Box pt={2} pb={2}>
              <Font variant={'subtitle1'} color={'secondary'}>
                <Text strong tId={'MANUAL_CHECK'} />
              </Font>
              <CustomDivider />
            </Box>
            {kyc.verification ? (
              <>
                <ReadOnlyDataRow labelTextId={'STATUS'} value={<Text tId={kyc.verification.status} />} />
                <ReadOnlyDataRow labelTextId={'VERIFIER'} value={getVerifierNameById(kyc.verification.verifierId)} />
                <ReadOnlyDataRow
                  labelTextId={'VERIFICATION_DATE'}
                  value={formatDateTimeReadable(kyc.verification.date)}
                />
                <ReadOnlyDataRow labelTextId={'DURATION'} value={kyc.verification.duration} valueUnit={'s'} />
              </>
            ) : (
              <PendingDataWarning type={PendingDataType.KYC_VERIFICATION} />
            )}
          </>
        </Grid>
        <Grid item xs={12}>
          <KycSecurityCheckList securityChecks={kyc.securityChecks} />
        </Grid>
      </Grid>
    </Box>
  );
}
